import update from 'immutability-helper'
import {
  LOAD_REPRESENTATIVES,
  SEARCH_REPRESENTATIVES,
  LOAD_REPRESENTATIVE,
  LOAD_STORES,
  SEARCH_STORES,
  LOAD_SELECTED_STORES,
  CLEAR_STORES,
  CLEAR_SELECTED_STORES,
  LOAD_STORE_SUCCESS,
  LOAD_SELECTED_STORE_SUCCESS,
  CLEAR_SELECTED_STORE,
  LOADING_REPRESENTATIVE_DETAILS,
  LOAD_PAYMENT_METHODS_BY_CHANNEL_SUCCESS,
  LOADING_INVOICE_DATA,
  LOAD_INVOICE_DATA_SUCCESS,
  LOADING_LOGOTYPE,
  LOAD_LOGOTYPE_SUCCESS,
  SET_INVOICE_DATA_SUCCESS,
  SET_LOGOTYPE_SUCCESS,
  EMPTY_INVOICE_DATA,
  EMPTY_LOGOTYPE,
  LOAD_CURRENT_STORE_DEBIT_DISABLED,
} from '../actions/action-types'
import { sendLoginEvent } from '../../util/ga-helpers'

const initialState = {
  stores: [],
  selectedStores: null,
  representatives: [],
  currentRepresentative: null,
  currentStore: null,
  currentSelectedStore: null,
  loadingDetails: false,
  invoiceDataLoading: false,
  invoiceData: {},
  currentPaymentMethodsByChannel: [],
  logotypeLoading: false,
  logotype: {},
  debitDisabled: false,
}

// eslint-disable-next-line default-param-last
const storeInfo = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_REPRESENTATIVES:
      return update(state, {
        representatives: {
          $set: action.response.representatives.sort((a, b) =>
            a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
          ),
        },
      })
    case SEARCH_REPRESENTATIVES:
      return update(state, {
        representatives: {
          $set: action.response.results.sort((a, b) =>
            a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
          ),
        },
      })
    case LOAD_REPRESENTATIVE:
      return update(state, {
        currentRepresentative: { $set: action.response },
      })
    case LOAD_STORES:
      return update(state, {
        stores: {
          $set: action.response.stores.sort((a, b) =>
            a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
          ),
        },
      })
    case SEARCH_STORES:
      return update(state, {
        stores: {
          $set: action.response.results.sort((a, b) =>
            a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
          ),
        },
      })
    case LOAD_SELECTED_STORES:
      return update(state, {
        selectedStores: { $set: action.response.stores },
      })
    case CLEAR_STORES:
      return initialState
    case CLEAR_SELECTED_STORES:
      return update(state, { selectedStores: { $set: null } })
    case LOAD_STORE_SUCCESS:
      sendLoginEvent(action.currentStore.accountSystemStoreId)
      return update(state, {
        currentStore: { $set: action.currentStore },
      })
    case LOAD_SELECTED_STORE_SUCCESS:
      return update(state, {
        currentSelectedStore: { $set: action.selectedStore },
      })
    case CLEAR_SELECTED_STORE:
      return update(state, { currentSelectedStore: { $set: null } })
    case LOADING_REPRESENTATIVE_DETAILS:
      return update(state, {
        loadingDetails: { $set: action.loading },
      })
    case LOADING_INVOICE_DATA:
      return update(state, {
        invoiceDataLoading: { $set: action.loading },
      })
    case LOAD_INVOICE_DATA_SUCCESS:
      return update(state, {
        invoiceData: {
          $set: action.response || {},
        },
      })
    case SET_INVOICE_DATA_SUCCESS:
      return update(state, {
        invoiceData: { $set: action.response },
      })
    case EMPTY_INVOICE_DATA:
      return update(state, {
        invoiceData: { $set: {} },
      })
    case LOADING_LOGOTYPE:
      return update(state, {
        logotypeLoading: { $set: action.loading },
      })
    case LOAD_LOGOTYPE_SUCCESS:
      return update(state, {
        logotype: { $set: action.response },
      })
    case SET_LOGOTYPE_SUCCESS:
      return update(state, {
        logotype: { $set: action.response },
      })
    case EMPTY_LOGOTYPE:
      return update(state, {
        logotype: { $set: {} },
      })
    case LOAD_PAYMENT_METHODS_BY_CHANNEL_SUCCESS:
      return update(state, {
        currentPaymentMethodsByChannel: {
          $set: action.response,
        },
      })
    case LOAD_CURRENT_STORE_DEBIT_DISABLED:
      return update(state, {
        debitDisabled: {
          $set: !action.response.debitEnabled,
        },
      })
    default:
      return state
  }
}

export default storeInfo
